module.exports = __webpack_public_path__ + "img/ic_paxelBox.b16dacdb.svg";